document.querySelectorAll('[data-sm-root]').forEach(init);
function init(root) {
  var sid = root.dataset.sid;
  var form = root.querySelector('[data-sm-form]');
  var bundles = root.querySelectorAll('[data-sm-bundle]');
  var slots = root.querySelectorAll('[data-sm-slot]');
  var track = root.querySelector('[data-sm-track]');
  var thumbs = root.querySelectorAll('[data-sm-thumb]');
  var errorEl = root.querySelector('[data-sm-error]');
  var btn = root.querySelector('[data-sm-submit]');
  var btnText = root.querySelector('[data-sm-btn-text]');
  var fallbackVariant = parseInt(root.dataset.fallback, 10);

  function qty() {
    var c = root.querySelector('input[name="sm-bundle-' + sid + '"]:checked');
    return c ? parseInt(c.value, 10) : 1;
  }
  function refresh() {
    var n = qty();
    bundles.forEach(function (b) { b.classList.toggle('is-selected', parseInt(b.dataset.smBundle, 10) === n); });
    slots.forEach(function (s) { s.hidden = parseInt(s.dataset.smSlot, 10) > n; });
  }
  function goTo(index) {
    if (!track) return;
    var slide = track.children[index];
    if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.dataset.smThumb, 10) === index); });
  }
  root.querySelectorAll('input[name="sm-bundle-' + sid + '"]').forEach(function (r) { r.addEventListener('change', refresh); });
  thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.smThumb, 10)); }); });
  if (track) {
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.dataset.smThumb, 10) === i); });
    }, { passive: true });
  }
  root.querySelectorAll('.sm-chip input').forEach(function (input) {
    input.addEventListener('change', function () {
      if (!track || !input.dataset.media) return;
      var slides = Array.prototype.slice.call(track.children);
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId === input.dataset.media; });
      if (idx > -1) goTo(idx);
    });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var n = qty();
    var counts = {};
    for (var s = 1; s <= n; s++) {
      var picked = root.querySelector('input[name="sm-slot-' + sid + '-' + s + '"]:checked');
      var id = picked ? picked.value : fallbackVariant;
      counts[id] = (counts[id] || 0) + 1;
    }
    var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
    btn.disabled = true;
    errorEl.hidden = true;
    var original = btnText.textContent;
    btnText.textContent = 'Lägger i varukorgen…';
    fetch(root.dataset.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = root.dataset.cart;
    }).catch(function () {
      errorEl.hidden = false;
      btn.disabled = false;
      btnText.textContent = original;
    });
  });

  var sticky = root.querySelector('[data-sm-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      sticky.classList.toggle('is-visible', !visible);
    });
    io.observe(form);
  }
  refresh();
}
